import { useState } from 'react';
import { Button, Group, Stack, Text } from '@mantine/core';
import { GlobalDocumentTemplateRes } from '@dealstack/shared/lib/generated';
import { ModalV2 } from '@dealstack/frontend/shared/components/ModalV2/ModalV2';
import { useDeleteDocumentTemplate } from '@dealstack/frontend/app/pages/DocumentTemplates/api/useDeleteDocumentTemplate';

interface Props {
	template: GlobalDocumentTemplateRes;
}

export const DeleteTemplateButton = ({ template }: Props) => {
	const [isConfirmOpen, setIsConfirmOpen] = useState(false);
	const deleteDocumentTemplate = useDeleteDocumentTemplate();

	return (
		<>
			<Button variant="ghost" c="red" onClick={() => setIsConfirmOpen(true)}>
				Delete
			</Button>
			{isConfirmOpen && (
				<ModalV2
					size="sm"
					onClose={() => setIsConfirmOpen(false)}
					reactModalProps={{
						shouldCloseOnOverlayClick: !deleteDocumentTemplate.isPending,
					}}
				>
					<Stack gap="md">
						<Text fw={600} size="lg">
							Delete &quot;{template.name}&quot;?
						</Text>
						<Text size="sm" c="dark.0">
							This document template will be permanently deleted and can no longer be
							used to generate documents.
						</Text>
						<Group justify="right" gap="xs">
							<Button
								variant="default"
								onClick={() => setIsConfirmOpen(false)}
								disabled={deleteDocumentTemplate.isPending}
							>
								Cancel
							</Button>
							<Button
								color="red"
								loading={deleteDocumentTemplate.isPending}
								disabled={deleteDocumentTemplate.isPending}
								onClick={() => {
									deleteDocumentTemplate.mutate(template.id, {
										onSuccess: () => setIsConfirmOpen(false),
									});
								}}
							>
								Delete
							</Button>
						</Group>
					</Stack>
				</ModalV2>
			)}
		</>
	);
};
